import { Box, Stack, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import { PlanCard } from 'theme/elements/Cards';
import { TableComponent } from 'components/TableComponent';
import { TextInput } from 'components/Inputs';
import { planInputType } from 'constants/business-plan.constants';

interface IProps {
	item: any;
	tableHeaderItems: any[];
	data: any[];
	handleInputChange: any;
	planToEdit: any;
	planName?: string;
}
export const BusinessPlanItem = ({ item, tableHeaderItems, data, handleInputChange, planToEdit, planName }: IProps) => {
	const theme = useTheme();

	return (
		<Stack spacing={2}>
			<Typography variant="h4" sx={{ fontWeight: '700', color: 'black', textTransform: 'capitalize' }}>
				{planName || item?.name} {planName ? `(${item?.name})` : ''}
			</Typography>
			<PlanCard
				key={item?.id}
				styleObj={{
					width: 'auto',
					flexDirection: 'column',
					boxShadow: '4px 4px 16px rgba(0, 58, 53, 0.6)',
					'& th': {
						textAlign: 'right',
					},
					position: 'relative',
					height: '-webkit-fill-available',
				}}
			>
				<>
					{!planToEdit ||
						(planToEdit && planToEdit?.id !== item?.id && (
							<Box
								sx={{
									width: '100%',
									height: '100%',
									position: 'absolute',
									background: 'white',
									borderRadius: '8px',
									opacity: 0.5,
								}}
							></Box>
						))}

					<TableComponent tableHeaderItems={tableHeaderItems}>
						{data &&
							data?.map((data: any, index: number) => {
								return (
									<TableRow
										key={index}
										sx={{
											'& tr': {
												display: 'block',
												justifyContent: 'unset',
											},
											'& td': {
												borderBottom: '1px solid',
												borderColor: theme.palette.root.divider,
												padding:
													!planToEdit || (planToEdit && planToEdit?.id !== data.idPointer)
														? 3
														: '15px 24px!important',
												width: 'auto',
											},
											'&:last-child td, &:last-child th': {
												border: 0,
											},
										}}
									>
										<TableCell sx={{ width: '200px' }}>
											<Typography variant="body">{data.fieldName}</Typography>
										</TableCell>
										{!planToEdit || (planToEdit && planToEdit?.id !== item?.id) ? (
											<TableCell sx={{ textAlign: 'center' }}>
												<Typography variant="body">
													{data.type === planInputType.CODE ? (
														<>{data.inputValue}</>
													) : (
														<>
															{data.sign}
															{'  '}
															{data.inputValue}
														</>
													)}
												</Typography>
											</TableCell>
										) : (
											<TableCell align="right">
												<Box
													sx={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'flex-end',
														gap: 1,
													}}
												>
													{data.sign}
													{'  '}
													<TextInput
														disabled={Boolean(data.disabled)}
														value={data.inputValue}
														label=""
														onChange={(event: any) =>
															handleInputChange(event, data.planPointer)
														}
														textFieldStyle={{
															width: data.type === planInputType.CODE ? 'auto' : '75px',
														}}
													/>
												</Box>
											</TableCell>
										)}
									</TableRow>
								);
							})}
					</TableComponent>
				</>
			</PlanCard>
		</Stack>
	);
};
